/* eslint-disable complexity */
(function(){
  window.Home = window.Home || {};

  let dialogTriggered = function(dialogId, triggerElement, analyticsTrackingString, dialogData) {
    window.HF.jsLoaded.then(() => {
      FS.Analytics.trackValue(analyticsTrackingString);
    });
    if (window.Home.dialogDependenciesLoaded) {
      window.Home.showDialog(dialogId, triggerElement, Promise.resolve(), dialogData)
    } else {
      window.Home.showDialog(dialogId, triggerElement, window.Home.loadDependencies([
        'components/fs-dialog/fs-dialog-all.html'
      ]), dialogData)
    }
  }

  let toggleDetails = function(element, uniqueId, style) {
    if (style === "none") {
      document.getElementById(uniqueId + 'Content').style.display = style;
      document.querySelector("div#"+ uniqueId+ " .detailsToggle").style.display = 'block';
    } else {
      document.querySelector("div#"+ uniqueId+ " .detailsToggle").style.display = 'none';
      document.getElementById(uniqueId + 'Content').style.display = style;
    }
  }

  Home.NLI_RESULTS = {};
  Home.NLI_RESULTS.dialogTriggered = dialogTriggered;

  // accessibility and analytics

  let displayContext = document.getElementById('main-content-section');

  // accessibility: specific keypresses trigger the onclick handler of custom clickable elements

  let customClickables = displayContext.getElementsByClassName('thisIsClickable');
  let enterButton = 13;
  let spaceBar = 32

  if (customClickables && customClickables.length) {
    Array.from(customClickables).forEach( clickableElement => clickableElement.addEventListener('keydown', function(event) {
      if ( event.keyCode === enterButton || event.keyCode === spaceBar ) {
        event.preventDefault();
        clickableElement.click();
      }
    }))
  }

  // analytics to track which panels or segments have been loaded and viewed

  let lowerPanels = displayContext.querySelectorAll('.trackViewportView');
  let emptySVGPlaceholder = displayContext.querySelector('#weDontHaveAnSVGForThisCountry')

  function trackElementView() {
    window.HF.jsLoaded.then(() => {
      FS.Analytics.trackValue(`${this.id}:viewed`)
    });
  }

  if ( lowerPanels && lowerPanels.length ){
    for (var i = 0; i < lowerPanels.length; i++) {
      Home.Behaviors.Viewport.watchBySelector( `#${lowerPanels[i].id}`, { bottomCallback: trackElementView.bind(lowerPanels[i]) } );
    }
  }

  if ( emptySVGPlaceholder ) {
    window.HF.jsLoaded.then(() => {
      FS.Analytics.trackValue( `${emptySVGPlaceholder.id}:${emptySVGPlaceholder.getAttribute('dbcountrycode')}` )
    });
  }

  if (displayContext.querySelector('#topBirthCountries')) window.HF.jsLoaded.then(() => FS.Analytics.trackValue('topBirthCountries:loaded'));
  if (displayContext.querySelector('#infoTable')) window.HF.jsLoaded.then(() => FS.Analytics.trackValue('infoTable:loaded'));
  if (displayContext.querySelector('#topPhotos')) window.HF.jsLoaded.then(() => FS.Analytics.trackValue('topPhotos:loaded'));

}());